interface SectionHeadingProps {
  index: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function SectionHeading({
  index,
  title,
  desc,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="mb-7 flex flex-col gap-4 border-b border-background-300 pb-4 sm:flex-row sm:items-end sm:justify-between md:mb-9">
      <div className="flex items-start gap-3 md:gap-4">
        <span className="font-heading text-2xl font-black leading-none text-accent-500 md:text-3xl">
          {index}
        </span>
        <div>
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {desc ? (
            <p className="mt-1.5 max-w-xl text-xs leading-relaxed text-foreground-600 md:text-sm">
              {desc}
            </p>
          ) : null}
        </div>
      </div>
      {actionLabel && actionHref ? (
        <a
          href={actionHref}
          className="group inline-flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap text-xs font-medium text-foreground-700 transition-colors hover:text-primary-600 md:text-sm"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
        </a>
      ) : null}
    </div>
  );
}